import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import HardwareIcon from '@mui/icons-material/Hardware';
import InterestsIcon from '@mui/icons-material/Interests';
import GroupsIcon from '@mui/icons-material/Groups';
// import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


export default function TemporaryDrawer() {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const { auth_user } = useSelector((state) => state.authUser);
  console.log('---auth_user:', auth_user);

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >

    {auth_user.user_type == 'Employee' && 
          <List>
          <ListItem component="a" href="/emp/update-profile" key='My Profile' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary='My Profile' />
            </ListItemButton>
          </ListItem>
          <ListItem component="a" href="/emp/create-bid" key='create_bid' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <HardwareIcon />
              </ListItemIcon>
              <ListItemText primary='Create Bid' />
            </ListItemButton>
          </ListItem>
          <ListItem component="a" href="/emp/bid-listing" key='Bid Listing' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText primary='Bid Listing' />
            </ListItemButton>
          </ListItem>
          <ListItem component="a" href="/emp/sellers-group-listing" key='Mng Sellers Group' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <GroupsIcon />
              </ListItemIcon>
              <ListItemText primary='Mng Sellers Group' />
            </ListItemButton>
          </ListItem>
          {/* <ListItem component="a" href="" key='Response on Bid' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <SouthWestIcon />
              </ListItemIcon>
              <ListItemText primary='Manege Resp Bids' />
            </ListItemButton>
          </ListItem> */}
        </List>
    }

{auth_user.user_type == 'Seller' && 
          <List>
          <ListItem key='My Profile' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary='My Profile' />
            </ListItemButton>
          </ListItem>
          <ListItem component="a" href="/seller/emp-bid-listing" key='Bid Listing' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText primary='Bid Listing' />
            </ListItemButton>
          </ListItem>
          <ListItem component="a" href="/seller/bid-listing" key='Response on Bid' disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <ArrowOutwardIcon />
              </ListItemIcon>
              <ListItemText primary='Response on Bid' />
            </ListItemButton>
          </ListItem>
        </List>
    }


      <Divider />
      <List>
        {['FAQ', 'Send Feedback'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InterestsIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <div>

      {/* {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))} */}


      <React.Fragment key={'left'}>
        <IconButton aria-label="menu" onClick={toggleDrawer('left', true)}><MenuIcon /></IconButton>

        <Drawer
          anchor={'left'}
          open={state['left']}
          onClose={toggleDrawer('left', false)}
        >
          {list('left')}
        </Drawer>
      </React.Fragment>

    </div>
  );
}